import axios from 'axios';
import config from 'shared/config';
import setBaseRequest from 'shared/utils/setBaseRequest';
import { asyncStart, asyncSuccess, asyncError } from 'redux/domain/AsyncStatus/actions';
import qs from 'qs';
import { batchActions } from 'redux-batched-actions';
import { createNotification } from 'redux/domain/Notifications/creators';
import keyPath from './keyPath';
import { destroySalespersonId } from './creators';

const validateSalespersonId = (asyncId, storisSalespersonId, settings) => async dispatch => {
	const asyncKeyPath = keyPath(asyncId);
	const cancellationSource = axios.CancelToken.source();
	// begin submission by setting async status and storing the cancellation source
	dispatch(asyncStart(asyncKeyPath, cancellationSource));
	let response;
	try {
		if (storisSalespersonId === '') {
			dispatch(createNotification(settings.fieldAndFooterSettings.NotificationSettings.EnterValidSalespersonNotificationText));
		} else {
			response = await axios.post(
				`${config.ESTORIS_BASE_PATH}/IsValidSTORISSalespersonId`,
				qs.stringify({ storisSalespersonId }),
				setBaseRequest({}, cancellationSource.token),
			);
			if (!response.data.valid) {
				dispatch(
					batchActions([
						createNotification(
							settings.fieldAndFooterSettings.NotificationSettings.ValidateSalespersonInvalidErrorNotificationText,
						),
						destroySalespersonId(),
						asyncSuccess(asyncKeyPath),
					]),
				);
			} else {
				dispatch(batchActions([asyncSuccess(asyncKeyPath)]));
			}
		}
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error
			dispatch(
				batchActions([
					asyncError(asyncKeyPath, error),
					createNotification(
						settings.fieldAndFooterSettings.NotificationSettings.ValidateSalespersonFetchErrorNotificationText,
					),
				]),
			);
		}
	}
	return response;
};

export default validateSalespersonId;
